import BaseMystery from '../BaseMystery'

const SecondSorrowfulMystery = () => {
	const imagesList = [
		"https://www.wga.hu/art/v/vecchiet/scourgin.jpg",
		"https://www.wga.hu/art/t/tiziano/06_1560s/02scourg.jpg",
		"https://www.wga.hu/art/s/signorel/various/1scourgi.jpg",
		"https://www.wga.hu/art/f/fernande/alejo/scourgin.jpg",
		"https://www.wga.hu/art/a/altdorfe/3/2scenes2.jpg",
		"https://www.wga.hu/art/c/caravagg/09/55flagel.jpg",
		"https://www.wga.hu/art/c/cimabue/madonna/panel2.jpg",
		"https://www.wga.hu/art/c/cranach/lucas_e/05/60religi.jpg",
		"https://www.wga.hu/art/c/crespi/daniele/flagella.jpg",
		"https://www.wga.hu/art/d/duccio/maesta/verso_2/verso16.jpg",
		"https://www.wga.hu/art/f/fernande/gregorio/column2.jpg",
		"https://www.wga.hu/art/g/gallego/flagella.jpg",
		"https://www.wga.hu/art/g/grassi_n/flagella.jpg",
		"https://www.wga.hu/art/g/guercino/1/flagella.jpg",
		"https://www.wga.hu/art/g/guercino/2/flagel_c.jpg",
		"https://www.wga.hu/art/g/guido/08poly.jpg",
		"https://www.wga.hu/art/h/huguet/flagella.jpg",
		"https://www.wga.hu/art/l/lorenzet/pietro/1/1vault/5flagel.jpg",
		"https://www.wga.hu/art/l/luca/flagella.jpg",
		"https://www.wga.hu/art/m/mariotto/life3.jpg",
		"https://www.wga.hu/art/m/master/bersword/bielefe1.jpg",
		"https://www.wga.hu/art/p/pacher/various/5salzbu1.jpg",
		"https://www.wga.hu/art/r/ratgeb/flagella.jpg",
		"https://www.wga.hu/art/r/romanino/cremona1.jpg",
		"https://www.wga.hu/art/r/rubens/7graphic/06sketch.jpg",
		"https://www.wga.hu/art/s/sebastia/flagella.jpg",
		"https://www.wga.hu/art/s/signorel/various/81flagel.jpg",
		"https://www.wga.hu/art/s/signorel/cortona/predell4.jpg",
		"https://www.wga.hu/art/s/sodoma/1/3predell.jpg",
		"https://www.wga.hu/art/u/ugolino/nerio/1/4prede3.jpg",
		"https://www.wga.hu/art/m/master/zunk_ge/zunk_ge4a/passion4.jpg",
		"https://www.wga.hu/art/m/master/zunk_hu/zunk_hu1/08flagel.jpg",
		"https://www.wga.hu/art/v/vassilac/flagella.jpg",
		"https://www.wga.hu/art/v/venusti/flagella.jpg",
		"https://www.wga.hu/art/z/zuccaro/federico/gonfaloy.jpg",
	];

	const scriptureQuote = "So Pilate, wishing to satisfy the crowd, released Barabbas to them and, after he had Jesus scourged, handed him over to be crucified.";
	const scriptureCitation = "Mark 15:15 (NABRE)";
	const citationLink = "https://www.biblegateway.com/passage/?search=Mark%2015%3A15&version=NABRE";

	return (
		<BaseMystery titleText="The Scourging at the Pillar"
				imagesList={imagesList}
				scriptureQuote={scriptureQuote}
				scriptureCitation={scriptureCitation}
				citationLink={citationLink}
				rightHanded={true} />
	);
};

export default SecondSorrowfulMystery;